// TAT Status Calculator for Frontend

export const TAT_STATUS = {
  WITHIN_TAT: 'WITHIN_TAT',
  BREACHED: 'BREACHED',
  WARNING: 'WARNING',
  PENDING: 'PENDING'
};

export const getTatStatusColor = (status) => {
  switch (status) {
    case TAT_STATUS.WITHIN_TAT:
      return 'success';
    case TAT_STATUS.BREACHED:
      return 'error';
    case TAT_STATUS.WARNING:
      return 'warning';
    case TAT_STATUS.PENDING:
    default:
      return 'default';
  }
};

export const getTatStatusLabel = (status) => {
  switch (status) {
    case TAT_STATUS.WITHIN_TAT:
      return '✅ Within TAT';
    case TAT_STATUS.BREACHED:
      return '❌ Breached';
    case TAT_STATUS.WARNING:
      return '⚠️ Warning';
    case TAT_STATUS.PENDING:
    default:
      return '⏸️ Pending';
  }
};

export const getOverallTatStatus = (stages) => {
  if (!stages) return TAT_STATUS.PENDING;
  
  // Check all stages
  const statuses = Object.values(stages).map(stage => stage.status);
  
  // If any stage is breached, overall is breached
  if (statuses.includes(TAT_STATUS.BREACHED)) {
    return TAT_STATUS.BREACHED;
  }
  
  // If any stage has warning, overall is warning
  if (statuses.includes(TAT_STATUS.WARNING)) {
    return TAT_STATUS.WARNING;
  }
  
  // If all completed stages are within TAT
  if (statuses.includes(TAT_STATUS.WITHIN_TAT)) {
    return TAT_STATUS.WITHIN_TAT;
  }
  
  return TAT_STATUS.PENDING;
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (e) {
    return dateString;
  }
};

export const calculateTimeDifference = (startDate, endDate) => {
  if (!startDate || !endDate) return null;
  
  try {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diff = end - start;
    
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
    if (hours > 24) {
      const days = Math.floor(hours / 24);
      const remainingHours = hours % 24;
      return `${days}d ${remainingHours}h`;
    }
    
    return `${hours}h ${minutes}m`;
  } catch (e) {
    return null;
  }
};

